module.exports = __webpack_public_path__ + "static/img/scmbanner3.659b77b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scmbanner3.png
// module id = uvJa
// module chunks = 1